import { apiRequest } from './apiClient';
const query=values=>new URLSearchParams(Object.entries(values).filter(([,v])=>v)).toString();
export const getPayrollConfiguration=()=>apiRequest('/api/payroll-periods/configuration');
export const schedulePayrollConfiguration=(payload,requestId)=>apiRequest('/api/payroll-periods/configuration',{method:'POST',headers:{'x-request-id':requestId},body:JSON.stringify(payload)});
export const getPayrollPeriods=filters=>apiRequest(`/api/payroll-periods/periods?${query(filters)}`);
export const getPayrollAllocations=filters=>apiRequest(`/api/payroll-periods/allocations?${query(filters)}`);
